import React from 'react';
import { PayrollContributionReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';

import { useFavoriteReportHandler } from '../hooks';
import { ReportTypeKeys } from '../report.types';

import ReportCardBase, { ReportCardBaseProps } from './ReportCardBase';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'payroll-report-card';
const PayrollReportCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.Payroll);

  return (
    <ReportCardBase
      // isNew
      testId={TEST_ID}
      isWideMode={isFavoriteMode}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      url={ROUTES.PAYROLL_CONTRIBUTION_REPORT}
      icon={
        <PayrollContributionReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Payroll Contributions"
      description="View payroll contribution details for HSA
and notional accounts"
    />
  );
};
export default PayrollReportCard;
